import { render, staticRenderFns } from "./SelectLessonsDialog.vue?vue&type=template&id=68ad37c6&"
import script from "./SelectLessonsDialog.vue?vue&type=script&lang=js&"
export * from "./SelectLessonsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports